import request from 'superagent'

import {getHeadersWithGRPC} from '@/services/api'
import {ISuperAgentResMultiple} from '@/api/response-typedf'
import {TListOptions} from '@/typedef'
import {rejectedReasonsApi} from '@/modules/ITSM/api/generate-itsm-api-url'

import {TRejectReason} from '../typedef'

export const postReason = async (data: TRejectReason) => {
  return await request
    .post(rejectedReasonsApi().post)
    .set(getHeadersWithGRPC())
    .send(data)
}

export const patchReason = async (uuid: string, data: TRejectReason) => {
  return await request
    .patch(rejectedReasonsApi(uuid).patch)
    .set(getHeadersWithGRPC())
    .send(data)
}

export const fetchReasons = async <T extends Record<string, any>>({
  resolve,
  passedBookmark,
  selector,
  sort,
}: TListOptions<T>): Promise<ISuperAgentResMultiple<T>> =>
  await request
    .options(rejectedReasonsApi().get + (resolve || ''))
    .set(getHeadersWithGRPC())
    .send({
      bookmark: passedBookmark,
      selector: {
        ...selector,
      },
      sort,
    })
